// extracted by mini-css-extract-plugin
export default {"root":"style_root__7T5Wc","vs":"style_vs__+SB-2","players":"style_players__DfICp"};